import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Input from "../../../../common/FormComponents/Input";
import { useState } from "react";
import Select from "../../../../common/FormComponents/Select";
import FormSectionGrid from "../../../../common/Form/FormSectionGrid";

const AnotherPerson = ({
  control,
  errors,
  pageText,
  type = "another",
  lookupDropdownData,
  setGivenNameEnable,
  candidateData,
  setInvoiceEmail,
  invoiceEmailError,
  taxNumberValid,
  onTaxNumberChange,
  clearErrors,
  setValue,
}: any) => {
  const [surnameAllow, setSurname] = useState(
    candidateData?.haveFamilyName === "1" ? true : false
  );
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleEmailChange = (e: any) => {
    const emailValue = e.target.value;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setInvoiceEmail(!emailPattern.test(emailValue));
  };

  const togglePhoneNumber = (e: any) => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;
      if (regex.test(value)) {
        setPhoneNumber(value);
      }
      if (value === "") {
        setPhoneNumber(value);
      }
  };

  return (
    <FormSectionGrid>
      <Grid xs={12} sm={6} className="field">
        {type === "another" ? (
          <Input
            name={`${type}.taxNumber`}
            control={control}
            errors={errors}
            outsideError={
              taxNumberValid
                ? pageText?.validationMessages.pleaseEnterVATNumber
                : undefined
            }
            onTaxNumber={onTaxNumberChange}
            placeholder={
              pageText?.labelsMetadata.taxNumberForAnotherPersonLabel
            }
            label={`${pageText?.labelsMetadata.taxNumberForAnotherPersonLabel}`}
          />
        ) : (
          <Input
            name={`${type}.taxNumber`}
            control={control}
            errors={errors}
            outsideError={
              taxNumberValid
                ? pageText?.validationMessages.pleaseEnterVATNumber
                : undefined
            }
            onTaxNumber={onTaxNumberChange}
            placeholder={pageText?.labelsMetadata.taxNumberForACompanyLabel}
            label={`${pageText?.labelsMetadata.taxNumberForACompanyLabel} *`}
            rules={{
              required: pageText?.validationMessages.pleaseEnterVATNumber,
            }}
          />
        )}
      </Grid>
      <Grid xs={12} sm={6} sx={{ display: { xs: "none", sm: "initial" } }} />
      {type === "another" && (
        <>
          <Grid
            xs={12}
            sm={6}
            className="field"
            sx={{ opacity: surnameAllow ? "0.5" : "1" }}
          >
            <Input
              name={`${type}.givenName`}
              control={control}
              placeholder={
                pageText?.validationMessages?.pleaseEnterInvoiceFamilyName
              }
              errors={errors}
              disabled={surnameAllow}
              label={`${pageText?.labelsMetadata?.invoiceFamilyNameLabel} *`}
              rules={{
                required: {
                  value: surnameAllow ? false : true,
                  message:
                    pageText?.validationMessages?.pleaseEnterInvoiceFamilyName,
                },
              }}
            />
          </Grid>
          <Grid xs={12} sm={6} className="field">
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    defaultChecked={candidateData?.haveFamilyName === "1"}
                    id="surname"
                    name="surname"
                    onChange={(e) => {
                      clearErrors(`${type}.givenName`);
                      if (e.target.checked) {
                        setValue(`${type}.givenName`, "N/A");
                      } else {
                        setValue(`${type}.givenName`, "");
                      }
                      setGivenNameEnable(e.target.checked);
                      setSurname(e.target.checked);
                    }}
                    sx={{
                      border: "1px solid #C8C8C8",
                      borderRadius: 0,
                      mr: 2,
                    }}
                  />
                }
                label={
                  <Typography fontSize="12px">
                    {pageText?.labelsMetadata?.invoiceIsDontHaveFamilyNameLabel}
                  </Typography>
                }
                sx={{ mt: { sm: 4 }, ml: 0 }}
              />
            </FormControl>
          </Grid>
          <Grid xs={12} className="field">
            <Input
              name={`${type}.surname`}
              control={control}
              placeholder={
                pageText?.validationMessages?.pleaseEnterInvoiceOtherName
              }
              errors={errors}
              label={`${pageText?.labelsMetadata?.invoiceOtherNameLabel} *`}
              rules={{
                required: pageText?.labelsMetadata?.pleaseEnterInvoiceOtherName,
              }}
            />
          </Grid>
        </>
      )}
      {type === "company" && (
        <Grid xs={12} className="field">
          <Input
            name={`${type}.companyName`}
            control={control}
            placeholder={
              pageText?.validationMessages?.pleaseEnterInvoiceCompanyName
            }
            errors={errors}
            label={`${pageText?.validationMessages?.invoiceCompanyName} *`}
            rules={{
              required:
                pageText?.validationMessages?.pleaseEnterInvoiceCompanyName,
            }}
          />
        </Grid>
      )}
      <Grid xs={12} sm={6} className="field">
        <Input
          name={`${type}.phoneNo`}
          control={control}
          placeholder={
            pageText?.validationMessages?.pleaseEnterInvoiceTelephoneNumber
          }
          errors={errors}
          value={phoneNumber}
          maxLength={15}
          onPhoneChange={togglePhoneNumber}
          label={`${pageText?.validationMessages?.invoiceTelephoneNumber} *`}
          rules={{
            required:
              pageText?.validationMessages?.pleaseEnterPhoneOrMobileNumber,
          }}
        />
      </Grid>
      <Grid xs={12} sm={6} className="field">
        <Input
          name={`${type}.email`}
          control={control}
          placeholder={pageText?.validationMessages?.pleaseEnterEmailAddress}
          errors={errors}
          outsideError={
            invoiceEmailError
              ? pageText?.validationMessages?.emailAddressIsNotValid
              : undefined
          }
          label={`${pageText?.labelsMetadata?.emailAddressLabel} *`}
          onEmailChange={handleEmailChange}
          rules={{
            required: pageText?.validationMessages?.emailAddressIsNotValid,
          }}
        />
      </Grid>
      <Grid xs={12} sm={6} className="field">
        <Select
          label={`${pageText?.labelsMetadata.invoiceCountryLabel} *`}
          classNamePrefix={"form_drop"}
          placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoiceCountryLabel}`}
          options={lookupDropdownData?.countries}
          control={control}
          errors={errors}
          name={`${type}.country`}
          rules={{
            required: {
              value: true,
              message: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoiceCountryLabel}`,
            },
          }}
        />
      </Grid>
      <Grid xs={12} sm={6} className="field">
        <Input
          name={`${type}.address`}
          type="text"
          control={control}
          placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoiceAddressLabel}`}
          errors={errors}
          maxLength={30}
          label={`${pageText?.labelsMetadata.invoiceAddressLabel} *`}
          rules={{
            required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoiceAddressLabel}`,
          }}
        />
      </Grid>
      <Grid xs={12} sm={6} className="field">
        <Input
          name={`${type}.postCode`}
          type="text"
          control={control}
          placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoicePostalCodeLabel}`}
          errors={errors}
          maxLength={15}
          label={`${pageText?.labelsMetadata.invoicePostalCodeLabel} *`}
          rules={{
            required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoicePostalCodeLabel}`,
          }}
        />
      </Grid>
      <Grid xs={12} sm={6} className="field">
        <Input
          name={`${type}.city`}
          type="text"
          control={control}
          placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoiceTownOrCityLabel}`}
          errors={errors}
          label={`${pageText?.labelsMetadata.townCityLabel} *`}
          rules={{
            required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.invoiceTownOrCityLabel}`,
          }}
        />
      </Grid>
    </FormSectionGrid>
  );
};
export default AnotherPerson;
